var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.031 8c3.308 0 6 2.692 6 6v4.472l2.764 5.528h-17.528l2.764-5.528v-4.472c0-3.308 2.692-6 6-6zM15.031 6c-4.418 0-8 3.582-8 8v4l-2.805 5.61c-0.566 1.131 0.402 2.39 1.838 2.39h17.934c1.436 0 2.404-1.258 1.838-2.39l-2.805-5.61v-4c0-4.418-3.582-8-8-8v0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.031 6c0 1.105-0.895 0-2 0s-2 1.105-2 0 0.895-2 2-2 2 0.895 2 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.031 26c0 1.105-0.895 2-2 2s-2-0.895-2-2 0.895 0 2 0 2-1.105 2 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityNotification);
export default __webpack_public_path__ + "static/media/unity_notification.cf66c3d637e71c5bf9720715f64bcf60.svg";
export { ForwardRef as ReactComponent };